import { parseCalendarUrl } from './utils/date';
import { MONTHS } from './constants';
import { PrinterMonthly } from './web-components/calendar-printers/printer-monthly';
import { getMonthName, localizePath, t } from './i18n';
import { absoluteUrl, applySocialMeta } from './seo/social-meta';

function initializePrinter() {
    const tip = document.querySelector('.tip');
    if (tip) {
        tip.textContent = t('print.tip');
    }

    const path = window.location.pathname;
    const parsed = parseCalendarUrl(path);

    if (!parsed) {
        const output = document.getElementById('calendar-output');
        if (output) output.innerHTML = `<p>${t('print.invalidUrl')}</p>`;
        applySocialMeta({
            title: t('meta.printTitle'),
            description: t('meta.printDescription'),
            url: absoluteUrl(localizePath(path) || '/'),
            twitterCard: 'summary_large_image',
        });
        return;
    }

    const monthIndex = MONTHS.indexOf(parsed.month);
    const monthName = getMonthName(monthIndex);

    const calendarTitle = document.getElementById('calendar-title');
    if (calendarTitle) {
        calendarTitle.textContent = t('print.monthHeading', { month: monthName, year: parsed.year });
    }

    const pageTitle = t('meta.printMonthTitle', { month: monthName, year: parsed.year });
    const pageDescription = t('meta.printMonthDescription', { month: monthName, year: parsed.year });
    const pagePath = localizePath(`/print-calendar/${parsed.month}-${parsed.year}`);

    applySocialMeta({
        title: pageTitle,
        description: pageDescription,
        url: absoluteUrl(pagePath),
        twitterCard: 'summary_large_image',
    });

    const printerComponent = document.getElementById('monthly-printer') as PrinterMonthly;
    if (printerComponent) {
        printerComponent.month = monthIndex;
        printerComponent.year = parsed.year;
        printerComponent.monthName = monthName;
    }
}

document.addEventListener('DOMContentLoaded', initializePrinter);
